import { addUtcCalendarMonths } from '../common/utils/dateUtils'

import type { PutUserPropertyRequest } from '../../models/user/User'

export const MANAGER_HUB_PROMOTION_SIGNAL_PROPERTY_NAME = 'promotionSignal.managerHub'

export const createManagerHubPromotionSignalRequestData = (timestamp: number): PutUserPropertyRequest => ({
  name: MANAGER_HUB_PROMOTION_SIGNAL_PROPERTY_NAME,
  value: String(timestamp),
  classType: 'String',
})

export const parseManagerHubPromotionSignalPropertyValue = (value: unknown): number | undefined => {
  if (typeof value !== 'string' || !/^\d+$/.test(value)) {
    return undefined
  }

  const timestamp = Number(value)
  return Number.isSafeInteger(timestamp) ? timestamp : undefined
}

export const isManagerHubPromotionSignalActive = (managerHubTimestamp: unknown, now: number = Date.now()): boolean => {
  if (
    typeof managerHubTimestamp !== 'number' ||
    !Number.isSafeInteger(managerHubTimestamp) ||
    managerHubTimestamp < 0 ||
    !Number.isSafeInteger(now) ||
    now < 0 ||
    managerHubTimestamp > now
  ) {
    return false
  }

  return now < addUtcCalendarMonths(managerHubTimestamp, 3)
}
